import { withPlugins, domEvents } from '@spon/plugins';

function ScrollToTarget({ plugins: { addEvents } }) {
	function onClick(event) {
		event.preventDefault();
		const { target } = event;

		// check target is link
		const anchorHash = target.getAttribute('href')
			? target.getAttribute('href')
			: target.closest('a').getAttribute('href');

		const element = document.querySelector(anchorHash);

		if (!element) return;

		window.scrollTo({
			top: element.getBoundingClientRect().top + window.pageYOffset,
			left: 0,
			behavior: 'smooth',
		});
	}

	addEvents({
		click: onClick,
	});
}

export default withPlugins(domEvents)(ScrollToTarget);
